<div class="modal-backdrop" [ngClass]="{ fade: isVisible, show: isVisible }">
  @if (isVisible) {
    <div class="modal" [ngClass]="{ fade: isVisible, show: isVisible }">
      <div class="modal-dialog {{ modalSize }}">
        <div class="modal-content">
          <ng-content select="[modal-header]"></ng-content>
          <ng-content select="[modal-body]"></ng-content>
          @if (popLoader) {
            <div class="custom-loader"></div>
          }
          <ng-content select="[modal-footer]"></ng-content>
        </div>
      </div>
    </div>
  }
</div>
